type ErrorLike = {
  message?: string;
  response?: {
    data?: {
      errors?: Array<string | undefined | null>;
      error?: Array<string | undefined | null>;
      ERROR?: string;
      data?: {
        errors?: Array<string | undefined | null>;
        ERROR?: string;
      };
      message?: string;
    };
  };
};

const getErrorMessage = (
  error: ErrorLike | string | null | undefined,
  fallback = 'Something went wrong',
): string => {
  if (!error) {
    return fallback;
  }

  if (typeof error === 'string') {
    return error;
  }

  const responseData = error.response?.data;
  const nestedResponseData = responseData?.data;

  const candidateMessages = [
    responseData?.errors?.[0],
    responseData?.error?.[0],
    responseData?.ERROR,
    responseData?.message,
    nestedResponseData?.errors?.[0],
    nestedResponseData?.ERROR,
    error.message,
    fallback,
  ];

  const message = candidateMessages.find(
    candidate => typeof candidate === 'string' && candidate.trim().length > 0,
  );

  return message || fallback;
};

export default getErrorMessage;
